import _jsx from "@babel/runtime-corejs3/helpers/esm/jsx";
/*
 * Copyright (C) 2022 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React, { useEffect } from 'react';
import { View } from '@instructure/ui-view';
import { Text } from '@instructure/ui-text';
import { Flex } from '@instructure/ui-flex';
import { TextInput } from '@instructure/ui-text-input';
import formatMessage from '../../../format-message';
import { showFlashAlert } from '../../../common/FlashAlert';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { getIcon, getFriendlyLinkType } from './linkUtils';
const getEditMessage = () => formatMessage('If left empty, link text will display as course link name');
export const LinkDisplay = ({
  linkText,
  placeholderText,
  linkFileName,
  published,
  handleTextChange,
  linkType
}) => {
  useEffect(() => {
    showFlashAlert({
      message: formatMessage('Selected {linkFileName}', {
        linkFileName
      }),
      type: 'info',
      srOnly: true
    });
  }, [linkFileName]);
  const Icon = getIcon(linkType);
  const linkTypeMessage = getFriendlyLinkType(linkType);
  const publishedMessage = published ? formatMessage('published') : formatMessage('unpublished');
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    "data-testid": "LinkDisplay"
  }, void 0, /*#__PURE__*/_jsx(View, {
    as: "div"
  }, void 0, /*#__PURE__*/_jsx(Flex, {}, void 0, /*#__PURE__*/_jsx(Flex.Item, {}, void 0, /*#__PURE__*/_jsx(TextInput, {
    "data-testid": "link-text-input",
    renderLabel: () => formatMessage('Text (optional)'),
    onChange: (_e, value) => handleTextChange(value),
    value: linkText,
    placeholder: placeholderText,
    messages: [{
      type: 'hint',
      text: getEditMessage()
    }]
  })))), /*#__PURE__*/_jsx(View, {
    as: "div",
    margin: "medium none medium none"
  }, void 0, /*#__PURE__*/_jsx(Flex, {
    margin: "small none small none"
  }, void 0, /*#__PURE__*/_jsx(Text, {
    weight: "bold"
  }, void 0, formatMessage('Current Link'))), /*#__PURE__*/_jsx(Flex, {
    margin: "small none none none"
  }, void 0, /*#__PURE__*/_jsx(Flex.Item, {
    padding: "0 x-small 0 small"
  }, void 0, /*#__PURE__*/_jsx(Text, {
    "data-testid": "icon-wrapper",
    color: published ? 'success' : 'primary'
  }, void 0, /*#__PURE__*/_jsx(Icon, {
    size: "x-small"
  }))), /*#__PURE__*/_jsx(Flex.Item, {
    padding: "0 x-small 0 0",
    shouldGrow: true,
    shouldShrink: true,
    textAlign: "start"
  }, void 0, /*#__PURE__*/_jsx(View, {
    as: "div"
  }, void 0, /*#__PURE__*/_jsx("span", {
    "data-testid": "selected-link-name"
  }, void 0, linkFileName), linkType && /*#__PURE__*/_jsx(ScreenReaderContent, {
    "data-testid": "screenreader_content"
  }, void 0, formatMessage('link type: {linkTypeMessage}', {
    linkTypeMessage
  }), linkType !== 'navigation' && publishedMessage))))));
};